import React, { useState } from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box
} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// Guidelines Data
const guidelines = [
  {
    title: 'Step 1: Verify Availability at Source',
    details: [
      'Search for the exact title on the FDA Guidance Documents page.',
      'Check if the Issued Date matches.',
      "If no exact match, consider it as 'Not Available at Source'.",
      'If a match is found, open the title link.',
      "If the page says 'Page Not Found', consider it as 'Not Available at Source'.",
      'If the page loads, check for a PDF link in FDA webpage itself.',
      "If no PDF, consider it as 'Not Available at Source'.",
      "If a PDF exists, consider it as 'Available at Source'."
    ]
  },
  {
    title: 'Step 2: Determine Change Type',
    details: [
      "If considered as 'Not Available at Source', check if the guidance is deleted.",
      "If Deleted, set status as 'Deleted'.",
      "If re-added, set status as 'Re-Added'."
    ]
  },
  {
    title: 'Step 3: Decide Notification Status',
    details: [
      "If the system's detected values are correct and no recent notification has been sent, select 'Yes' for sending a notification.",
      'You can view the recently sent notification by clicking the "Show Recently Sent Notifications" button',
      "If a notification was recently sent, select 'No'."
    ]
  },
  {
    title: 'Step 4: Check for Duplicate Entries',
    details: [
      'If multiple entries exist for the same document, check the Recently Curated List.',
      "If already curated, answer Step 1 & 2, but set 'Notification can be sent?' to 'No'."
    ]
  },
  {
    title: 'Step 5: Add QC Notes (if needed)',
    details: ['Provide any additional details or observations.']
  }
];

const HelpDrawer = () => {
  const [open, setOpen] = useState(false);

  const toggleDrawer = (state: boolean) => () => {
    setOpen(state);
  };

  return (
    <>
      <IconButton onClick={toggleDrawer(true)} sx={{ position: 'fixed', top: 72, right: 16 }}>
        <HelpOutlineIcon />
      </IconButton>
      <Drawer anchor='right' open={open} onClose={toggleDrawer(false)}>
        <Box sx={{ width: 400, p: 2 }}>
          <Box display='flex' justifyContent='space-between' alignItems='center'>
            <Typography variant='h6'>Curation Guidelines</Typography>
            <IconButton onClick={toggleDrawer(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
          <List>
            {guidelines.map(({ title, details }) => (
              <Accordion key={title}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant='subtitle1'>{title}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <List disablePadding>
                    {details.map((item, index) => (
                      // eslint-disable-next-line react/no-array-index-key
                      <ListItem key={index} sx={{ pl: 2 }}>
                        <ListItemText primary={`• ${item}`} />
                      </ListItem>
                    ))}
                  </List>
                </AccordionDetails>
              </Accordion>
            ))}
          </List>
        </Box>
      </Drawer>
    </>
  );
};

export default React.memo(HelpDrawer);
